export default __webpack_public_path__ + "static/noissuetv-background-top-a0bfe6c3ec00e95128e75b489a8d9f68.svg";